/**
 * Loading screen with animated spinner
 */

import { Loader2 } from 'lucide-react';

type LoadingScreenProps = {
  message?: string;
};

export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps = {}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4">
        <div className="relative">
          <div className="h-16 w-16 rounded-full border-4 border-primary/20"></div>
          <Loader2 className="absolute inset-0 h-16 w-16 animate-spin text-primary" />
        </div>
        <div className="text-center space-y-1">
          <p className="text-lg font-medium">{message}</p>
          <p className="text-sm text-muted-foreground">Please wait</p>
        </div>
      </div>
    </div>
  );
}
